module.exports = __webpack_public_path__ + "img/icon-home.27e43988.svg";